import { useRef, useState, useEffect } from 'react'
// Components
import HeroImage from './Components/HeroImage';
import ServiceInfoBox from './Components/ServiceInfoBox'
import BigServiceTab from './Components/BigServiceTab'
import ServiceCallToAction from './Components/ServiceCallToAction'
import StatsTable from './Components/StatsTable';
import ServiceList from './Components/ServiceList'
// Images
import ElectricianImage from '../../images/slider_image2.jpg';
import CleanerImage from '../../images/slider_image3.jpg';
import MainImage from '../../images/main-page-new.jpg';
import PestImage from '../../images/slider_image1.jpg'

// utils
import { ServiceInfoBoxContent } from './utils';
import { serviceInfoStatistic } from './utils';
import { BigServiceBox } from './utils'

// redux
import { getBasicServiceRecommandation } from '../../actions'
import { connect } from 'react-redux'
const MainImagebullets = [
    'Doorstep repair within 90 mins',
    'Protection against damage upto INR 10,000',
    '30 Days posts-service guarantee'
]

const accordianItem = [
    {
        title: 'How much advance will i have to pay in case the work requires more then one visit?',
        content: 'In case you need a revisit from the same issue, it get covered in our 30-day service guarantee policy hence it is free of cost.'
    },
    {
        title: 'What are the inspection charges?',
        content: 'In case the expert was called and no serv ice was availed you will be entitled to pay him the visiting charges of Rs. 99.'
    },
    {
        title: 'Is there any other way to calculate the price if i want to hire professional for long durations?',
        content: 'If the professional is needed for longer duration such as for a day you can talk to him about the same. In this case he will provide you with the quotation. We make sure that this quation is less them the market price.'
    },
    {
        title: 'Do you carry out Domistic and industrial work?',
        content: 'Yes! space is no bar to your electrical needs at CorwCare as we provide services to all kind of varied customers.'
    },
    {
        title: 'Can i give a feedback on the service?',
        content: 'We encourage all our customers to rate and review the professionals on the App (or website) so that it may be helpfull for other customers as well.'
    }

]
// const BigServiceBox = {
//     title: 'Electricians in Mumbai',
//     desc: 'In this age and time, life is indeed impossible without electricity. It seems difficult to survive even through a power cut of only 15 minutes. Any small breakdown or malfunction can bring our entire routine to a standstill. Life in a place like Mumbai doesn’t really give you time to get such problems fixed. Searching for a reliable and licensed electrician in Mumbai is a task in itself. At the same time, any electric faults can’t be left unattended. f you find yourself stuck in such a situation, don’t worry. <strong>CoreCare brings you the best electricians at home in Mumbai, NaviMumbai and Pune.',
// }
const Services = (props) => {
    const [serviceListActive, setServiceListActive] = useState(false);
    const [serviceListVisible, setServiceListVisible] = useState(false)
    const ServiceListRef = useRef()
    // search_param will only be defined when user uses search box on main page and redirect to service page
    // seacrh param will be passed as prop to ServiceInfoBox component to trigger an click event on it if search param is defined to open ServiceList when search
    // it will also be passed to ServiceList component and then SubcategoryContent component to scroll in to view searched service category
    const {afzal: search_param, category: service_category} = props.match.params
    const { getBasicServiceRecommandation } = props

    // Cleanup servicelist state before unmounting service page using useEffect()
    useEffect(() => {
        return () => {
            setServiceListActive(false)
        }
    }, [search_param])

    // basic Recommander
    useEffect(() => {
        getBasicServiceRecommandation()
    }, [getBasicServiceRecommandation])

    const call2ActioncustomerClicked = () => {
        toggleServiceList()
    }
    const call2ActionemployeeClicked = () => {
        console.log('Employee')
    }
    const toggleServiceList = () => {
        
        if (!serviceListVisible){
            setServiceListActive(!serviceListActive)
            setTimeout(() => setServiceListVisible(!serviceListVisible), 50)
        }
        else{
            setServiceListVisible(!serviceListVisible)
            setTimeout(() => setServiceListActive(!setServiceListActive), 400)
        }
    }
    const renderImage = () => {
        switch(service_category){
            case 'electrician':
                return ElectricianImage
            case "cleaner":
                return CleanerImage
            case 'pest-control':
                return PestImage
            default:
                return MainImage
        }
    }
    const renderTitle = () => {
        switch(service_category){
            case 'ac-service-repair':
                return 'AC Expert'
            default:
                return service_category[0].toUpperCase() + service_category.slice(1)
        }

    }
    const renderServiceInfoBoxContent = () => {
            switch (service_category){
                case 'pest-control':
                    return ServiceInfoBoxContent.electrician
                case 'ac-service-repair':
                    return ServiceInfoBoxContent.ac
                case 'appliance-repair':
                    return ServiceInfoBoxContent.electrician
                default:
                    return ServiceInfoBoxContent[service_category]
            }
    }
    const renderBigServiceBoxText = () => {
        switch (service_category){
            case 'pest-control':
                return BigServiceBox.electrician
            case 'ac-service-repair':
                return BigServiceBox.ac
            case 'appliance-repair':
                return BigServiceBox.electrician
            default:
                return BigServiceBox[service_category]
        }
    }
    const renderStatictic = () => {
        switch (service_category){
            case 'pest-control':
                return serviceInfoStatistic.electrician
            case 'ac-service-repair':
                return serviceInfoStatistic.ac
            case 'appliance-repair':
                return ServiceInfoBoxContent.electrician
            default:
                return serviceInfoStatistic[service_category]
        }
    }
    const renderedStats = renderStatictic()
    return (
        <>  
            {serviceListActive ? <ServiceList category={service_category} active={serviceListVisible} setActive={toggleServiceList} reference={ServiceListRef} searchParam={search_param} recommended={props.recommended}/> : ""}
            <HeroImage mainTitle={`Get Professional ${renderTitle()}`} src={renderImage()} bullets={MainImagebullets}/>
            <ServiceInfoBox title={`Need an ${renderTitle()} for`} content={renderServiceInfoBoxContent()} rating={renderedStats.rating} ratingCount={renderedStats.ratingCount} bookingDone={renderedStats.bookingDone} onClick={call2ActioncustomerClicked} searchParam={search_param}/>
            <BigServiceTab serviceCategory={renderTitle()} accordianItem={accordianItem} about={renderBigServiceBoxText()} category={service_category}/>
            <ServiceCallToAction title={`Looking to hire Professionals ${renderTitle()}`} buttonText="Give Requirements" desc="Tell us your requirements and get custom quotes with profiles within 24 hours from upto 5 interested professionals." onClick={call2ActioncustomerClicked}/>
            <ServiceCallToAction title="Are you an Expert looking for Customers?" buttonText="Join Now" desc="" onClick={call2ActionemployeeClicked}/>
            <StatsTable />
        </>

    )
}
const mapStateToProps = (state) => {
    return {
        recommended: state.basicServiceRecommandation
    }
}
export default connect(mapStateToProps, { getBasicServiceRecommandation })(Services)